// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__97Nxu","controls":"styles_controls__3VGsE","charLimit":"styles_charLimit__3nP1w","input":"styles_input__ry1oO","send":"styles_send___Q5Ac"};